/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sendmagiclink2Inputs */

const zh_auth_sendmagiclink2 = /** @type {(inputs: Auth_Sendmagiclink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送登录链接`)
};

const en_auth_sendmagiclink2 = /** @type {(inputs: Auth_Sendmagiclink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send magic link`)
};

const es_auth_sendmagiclink2 = /** @type {(inputs: Auth_Sendmagiclink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar enlace mágico`)
};

/**
* | output |
* | --- |
* | "Send magic link" |
*
* @param {Auth_Sendmagiclink2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_sendmagiclink2 = /** @type {((inputs?: Auth_Sendmagiclink2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sendmagiclink2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_sendmagiclink2(inputs)
	if (locale === "en") return en_auth_sendmagiclink2(inputs)
	return es_auth_sendmagiclink2(inputs)
});
export { auth_sendmagiclink2 as "auth_sendMagicLink" }